var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "./ContactPerson"], function (require, exports, ContactPerson_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var AccessTypes;
    (function (AccessTypes) {
        AccessTypes[AccessTypes["None"] = 0] = "None";
        AccessTypes[AccessTypes["Read"] = 1] = "Read";
        AccessTypes[AccessTypes["Create"] = 2] = "Create";
        AccessTypes[AccessTypes["Update"] = 4] = "Update";
        AccessTypes[AccessTypes["Delete"] = 8] = "Delete";
    })(AccessTypes = exports.AccessTypes || (exports.AccessTypes = {}));
    var AccessRight = (function () {
        function AccessRight(id_, right_) {
            this.Right = 15;
            this.Id = null;
            this.Id = id_;
            this.Right = right_;
        }
        return AccessRight;
    }());
    exports.AccessRight = AccessRight;
    var SecurityInfo = (function () {
        function SecurityInfo() {
            this.Groups = [];
            this.Roles = [];
            this.Assignment = [];
        }
        return SecurityInfo;
    }());
    exports.SecurityInfo = SecurityInfo;
    var RoomAssignment = (function (_super) {
        __extends(RoomAssignment, _super);
        function RoomAssignment() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return RoomAssignment;
    }(AccessRight));
    exports.RoomAssignment = RoomAssignment;
    var LocationAssignment = (function () {
        function LocationAssignment(accessRight_Id_, accessRight_Right_, rooms_) {
            if (rooms_ === void 0) { rooms_ = []; }
            this.AccessRight = null;
            this.Rooms = [];
            this.AccessRight = new AccessRight(accessRight_Id_, accessRight_Right_);
            this.Rooms = rooms_;
        }
        return LocationAssignment;
    }());
    exports.LocationAssignment = LocationAssignment;
    var TenantAssignment = (function () {
        function TenantAssignment(accessRight_Id_, accessRight_Right_, locations_) {
            if (locations_ === void 0) { locations_ = []; }
            this.AccessRight = null;
            this.Locations = [];
            this.AccessRight = new AccessRight(accessRight_Id_, accessRight_Right_);
            this.Locations = locations_;
        }
        return TenantAssignment;
    }());
    exports.TenantAssignment = TenantAssignment;
    var Group = (function (_super) {
        __extends(Group, _super);
        function Group() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.Name = null;
            _this.AssignedRoles = [];
            return _this;
        }
        return Group;
    }(SecurityInfo));
    exports.Group = Group;
    var User = (function (_super) {
        __extends(User, _super);
        function User() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.LastLogonAt = new Date();
            _this.LastIP = null;
            _this.LogonCount = 0;
            _this.Password = null;
            _this.PasswordConfirmation = null;
            _this.RolesList = [];
            _this.SecurityInfo = new SecurityInfo();
            _this.IsLocked = false;
            return _this;
        }
        return User;
    }(ContactPerson_1.ContactPerson));
    exports.User = User;
});
//# sourceMappingURL=User.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Models/User.js
// module id = 159
// module chunks = 0